import { RHFSelect } from '@talentmesh/ui/components/rhf-select';
import type { DropdownOption } from '@talentmesh/utils';
import { useMemo } from 'react';

import { JobDetailsFieldTypes } from '../JobDetailsStepUtils';
import UIStrings from '@/Utils/UIStrings';

interface JobPostingOptionsProps {
    companyName: string;
    clientName: string;
    disabled?: boolean;
}

function getJobPostingOptions(companyName: string, clientName: string): DropdownOption[] {
    return [
        { id: 'OnBehalf', name: UIStrings.CompanyOnBehalfOfClient(companyName, clientName) },
        { id: 'OnBehalfNoNamedBasis', name: UIStrings.CompanyOnBehalfOfClientNoNameBasis(companyName, clientName) },
    ];
}

function JobPostingOptions({ companyName, clientName, disabled }: JobPostingOptionsProps) {
    const options = useMemo(() => {
        return getJobPostingOptions(companyName, clientName).map((o) => ({ id: String(o.id), name: o.name }));
    }, [companyName, clientName]);

    return (
        <RHFSelect
            label={UIStrings.HowDoYouWantToPostTheJob}
            name={JobDetailsFieldTypes.JobPostingType}
            disabled={disabled}
            options={options}
            fieldDataCy={JobDetailsFieldTypes.JobPostingType}
        />
    );
}

export default JobPostingOptions;
